import script from "./PublishingOverview.vue?vue&type=script&setup=true&lang=ts"
export * from "./PublishingOverview.vue?vue&type=script&setup=true&lang=ts"

import "./PublishingOverview.vue?vue&type=style&index=0&id=49d34345&lang=scss"

const __exports__ = script;

export default __exports__